import { useTranslation } from 'react-i18next';
import { HubertButton } from 'components/HubertUI/HubertButton';
import MutedText from 'components/common/MutedText';

type Props = {
  page: number;
  pageCount: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
};

const OptionsPagination = ({ page, pageCount, pageSize, total, onPageChange }: Props) => {
  const { t } = useTranslation('Questionsv2');
  const from = page * pageSize + 1;
  const to = Math.min((page + 1) * pageSize, total);

  return (
    <div className="flex items-center justify-center gap-4 p-2">
      <HubertButton variant="outline" size="sm" disabled={page <= 0} onClick={() => onPageChange(page - 1)}>
        {t('typeSpecificEditor.pagination.previous')}
      </HubertButton>
      <MutedText text={t('typeSpecificEditor.pagination.range', { from, to, total })} />
      <HubertButton variant="outline" size="sm" disabled={page >= pageCount - 1} onClick={() => onPageChange(page + 1)}>
        {t('typeSpecificEditor.pagination.next')}
      </HubertButton>
    </div>
  );
};

export default OptionsPagination;
